'use client';

import dynamic from 'next/dynamic';

export const AnueService = dynamic(() => import('@/components/molecules/AnueService'));
